<template>
	<div
		class="px-4 formField"
		v-if="isVisible"
		style="display: flex; align-items: center"
	>
		<v-switch
			:disabled="formField.Readonly"
			v-model="selectedValue"
			:rules="validationRules"
			:error-messages="validationError"
			:label="formField.Label"
			hide-details="auto"
		>
			<template v-slot:prepend v-if="visibleBubble || visibleHelp">
				<div v-if="visibleBubble">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								tabindex="-1"
								>mdi-information-outline</v-icon
							>
						</template>
						{{ bubbleText }}
					</v-tooltip>
				</div>
				<div v-if="visibleHelp">
					<v-tooltip
						top
						nudge-top="20"
						:open-on-click="true"
						:open-on-focus="true"
						:open-on-hover="true"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								color="primary"
								v-bind="attrs"
								v-on="on"
								tabindex="-1"
								>mdi-help-circle-outline</v-icon
							>
						</template>
						{{ helpText }}
					</v-tooltip>
				</div>
			</template>
		</v-switch>
		<div class="ml-2" v-if="canRetainValue">
			<v-icon v-if="!hasRetainedValue" @click="onPinClick"
				>mdi-pin-off-outline</v-icon
			>
			<v-icon v-else color="primary" class="rotate45" @click="onPinClick"
				>mdi-pin-outline</v-icon
			>
		</div>
	</div>
</template>
<script>
import formFieldMixin from '../../../../mixins/inventoryForm/formFieldMixin';
export default {
	name: 'BooleanField',
	mixins: [formFieldMixin],
	mounted() {
		this.defaultRules.push((v) => {
			if (this.formField.Required && !this.isBulkEdit) {
				if (!v) return false || 'The value is required';
				else return true;
			} else return true;
		});
		if (this.recordSelectedValue) {
			this.selectedValue = this.recordSelectedValue;
		}
	},

	methods: {
		onRecordChanged() {
			if (
				this.recordSelectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = this.recordSelectedValue;
				return;
			}

			if (
				this.selectedValue &&
				this.selectedValue != this.recordSelectedValue
			) {
				this.selectedValue = false;
			}
		},
		onHideFormField() {
			this.selectedValue = false;
		},

		onSelectedValueChanged(newVal) {
			this.skipNextRecordUpdate = true;
			this.$emit('selectedValueChanged', [
				{ key: this.recordKeys[0], value: newVal },
			]);
		},
		onSetInteraction(setValue) {
			this.onSelectedValueChanged(setValue);
		},
		onClearInteraction() {
			this.onSelectedValueChanged(null);
		},
	},
};
</script>
